import { useQuery } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { planningKeys } from '../queries/keys';
import { planningPaths } from '../queries/paths';

// TSS vite/03 — planificador de OPU (GET /admin/reproduction/planning, 0085 · Q-251).
// Read-only, permiso kpis:read. `params` = { mode:'coverage'|'recipients', target?|recipients?,
// gamma?, farm_id? }. Se dispara solo cuando la meta del modo está presente (el backend
// PROHÍBE el campo de la meta del otro modo → el llamador manda solo el que corresponde).
export function useOpuPlan(params) {
    const ready = !!params && (
        (params.mode === 'coverage' && params.target != null) ||
        (params.mode === 'recipients' && params.recipients != null)
    );
    return useQuery({
        queryKey: planningKeys.plan(params),
        queryFn:  ({ signal }) => api.get(planningPaths.opuPlan(), { params, signal }).then(r => r.data),
        enabled:  ready,
        placeholderData: (prev) => prev,
    });
}
